import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Main from "./components/layout/Main";
import { authProtectedRoutes, publicRoutes } from "./routes";
import { AuthContext } from "./AuthContext";
import { NotificationProvider } from "./NotificationProvider";
import { RefreshProvider } from "./RefreshContext";
import ProtectedRoute from "./ProtectedRoute";

import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import "./assets/styles/theme.css";

function App() {
  const { authToken } = useContext(AuthContext);

  return (
    <React.Fragment>
      <RefreshProvider>
        <NotificationProvider>
          <Routes>
            {/* Public Routes */}
            {publicRoutes.map((route, idx) => (
              <Route path={route.path} element={route.component} key={idx} />
            ))}

            {/* Protected Routes */}
            {authProtectedRoutes.map((route, idx) => (
              <Route
                key={idx}
                path={route.path}
                element={
                  <ProtectedRoute>
                    <Main>{route.component}</Main>
                  </ProtectedRoute>
                }
              />
            ))}

            {/* If no route matches */}
            <Route
              path="*"
              element={
                authToken ? (
                  <Navigate to={authProtectedRoutes[0].path} />
                ) : (
                  <Navigate to="/sign-in" />
                )
              }
            />
          </Routes>
        </NotificationProvider>
      </RefreshProvider>
    </React.Fragment>
  );
}

export default App;
